import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AlertType } from '@carm/_core/alerts/models/alert.model';
import { NotificationTypes } from '@carm/_core/notification-mgt/models/notification.model';

@Component({
  selector: 'carm-alerts-view',
  templateUrl: './alerts-view.component.html',
  styleUrls: ['./alerts-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertsViewComponent implements OnInit {
  @Input() alertType: AlertType | NotificationTypes;
  @Input() title: string;
  @Input() alertNumber: string;
  @Input() contentDetailLink: string;
  @Input() content: string | {controlName: string, message: string }[];
  @Input() multiple = false;
  @Input() inId = '';
  @Input() marginBottom = false;

  constructor() { }

  ngOnInit() {
  }

  /**
   * Css class
   * @param alertType i.e SUCCESS or ERROR or INFO etc
   * @returns css class as per AlertType
   */
  cssClass(alertType: AlertType | NotificationTypes) {
    if (!alert) {
        return;
    }
    // return css class based on alert type
    switch (alertType) {
        case AlertType.Success:
        case NotificationTypes.Success:
            return 'alert alert-success carm-alerts';
        case AlertType.Attention:
        case NotificationTypes.Error:
            return 'alert alert-danger carm-alerts';
        case AlertType.Info:
        case NotificationTypes.Info:
            return 'alert alert-info carm-alerts';
        case AlertType.Warning:
        case NotificationTypes.Warning:
            return 'alert alert-warning carm-alerts';
    }
}

}
